import { Link } from "react-router-dom";

const categories = [
  {
    id: 1,
    name: "Living Rooms",
    description: "Soft beige spaces, natural light, and warm minimal styling.",
    buttonLabel: "View Living Rooms",
    path: "/living-room",
    image: "https://public.readdy.ai/ai/img_res/501e48a468778641045443eaaa243afe.jpg",
  },
  {
    id: 2,
    name: "Neutral Rugs",
    description: "Warm-toned rugs that ground a room and make it feel complete.",
    buttonLabel: "Browse Neutral Rugs",
    path: "/products/neutral-rugs",
    image: "https://readdy.ai/api/search-image?query=neutral%20area%20rug%20warm%20ivory%20oat%20living%20room%20natural%20light%20calm%20editorial%20interior%20photography%20soft%20texture%20layered%20neutral%20palette%20beige%20sofa%20wood%20floor&width=640&height=820&seq=browse_cat_rugs&orientation=portrait",
  },
  {
    id: 3,
    name: "Beige Sofas",
    description: "Calm, comfortable, and built to last — the best beige sofas for a warm living room.",
    buttonLabel: "Browse Beige Sofas",
    path: "/cozy-corners/best-beige-sofas",
    image: "https://readdy.ai/api/search-image?query=beige%20linen%20sofa%20warm%20living%20room%20afternoon%20sunlight%20natural%20oak%20wood%20floor%20cream%20cushions%20dried%20botanicals%20calm%20elegant%20editorial%20interior%20photography%20serene%20atmosphere%20neutral%20palette&width=640&height=820&seq=browse_cat_sofas&orientation=portrait",
  },
  {
    id: 4,
    name: "Linen Curtains",
    description: "Soft, airy curtains that filter light and complete a neutral room.",
    buttonLabel: "Browse Linen Curtains",
    path: "/products/linen-curtains",
    image: "https://readdy.ai/api/search-image?query=linen%20curtains%20floor%20to%20ceiling%20soft%20beige%20room%20warm%20natural%20light%20sheer%20fabric%20calm%20elegant%20editorial%20interior%20photography%20neutral%20warm%20palette%20serene%20atmosphere&width=640&height=820&seq=browse_cat_curtains&orientation=portrait",
  },
  {
    id: 5,
    name: "Small Apartment Soft Neutrals",
    description: "How to make a compact space feel calm, open, and beautifully considered with a warm neutral palette.",
    buttonLabel: "Read the Guide",
    path: "/living-room/small-apartment-soft-neutrals",
    image: "https://readdy.ai/api/search-image?query=small%20apartment%20living%20room%20soft%20neutral%20palette%20cream%20beige%20warm%20ivory%20minimal%20furniture%20natural%20light%20linen%20sofa%20compact%20elegant%20editorial%20interior%20photography%20serene%20calm%20atmosphere&width=640&height=820&seq=browse_cat_smallapt&orientation=portrait",
  },
  {
    id: 7,
    name: "Calm Bedroom Neutrals",
    description: "A warm neutral palette, natural textures, and thoughtful layering for a truly restful bedroom.",
    buttonLabel: "Read the Guide",
    path: "/bedroom/calm-bedroom-neutrals",
    image: "https://readdy.ai/api/search-image?query=serene%20calm%20bedroom%20neutral%20palette%20warm%20ivory%20cream%20linen%20bedding%20natural%20oak%20wood%20furniture%20soft%20morning%20light%20sheer%20curtains%20minimal%20elegant%20editorial%20interior%20photography%20peaceful%20atmosphere&width=640&height=820&seq=browse_cat_bedroom&orientation=portrait",
  },
  {
    id: 6,
    name: "Coffee Tables",
    description: "Light wood coffee tables that add warmth and natural structure to a calm living room.",
    buttonLabel: "Browse Coffee Tables",
    path: "/products/wood-coffee-tables",
    image: "https://readdy.ai/api/search-image?query=light%20oak%20round%20coffee%20table%20beige%20living%20room%20warm%20afternoon%20sunlight%20natural%20wood%20grain%20calm%20elegant%20editorial%20interior%20photography%20neutral%20warm%20palette%20serene%20atmosphere&width=640&height=820&seq=browse_cat_coffee&orientation=portrait",
  },
];

export default function BrowseBySpace() {
  return (
    <section className="py-28 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        {/* Header */}
        <div className="text-center mb-16">
          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Shop by Product
          </p>
          <h2
            className="text-[#2C2825] text-4xl md:text-5xl mb-4"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            Browse Product Guides
          </h2>
          <p
            className="text-[#8B8378] text-sm leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Curated guides for every key piece in a calm, considered home.
          </p>
        </div>

        {/* Category Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <div key={cat.id} className="group flex flex-col">
              {/* Image */}
              <div className="relative overflow-hidden rounded-xl aspect-[4/5] bg-[#EDE6DA] mb-6">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
              </div>

              {/* Text */}
              <h3
                className="text-[#2C2825] text-2xl mb-2"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
              >
                {cat.name}
              </h3>
              <p
                className="text-[#8B8378] text-sm leading-relaxed mb-5 flex-1"
                style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
              >
                {cat.description}
              </p>
              <Link
                to={cat.path}
                className="self-start inline-flex items-center gap-2 border border-[#C8BAA8] text-[#6B5E53] px-6 py-2.5 rounded-full text-xs tracking-[0.15em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {cat.buttonLabel}
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-[11px]" />
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
